import React, { Component } from 'react'
import Axios from 'axios';
import { MDBBtn, MDBIcon, MDBCard, MDBCardBody, MDBContainer, MDBBox, MDBAlert,MDBBadge   } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Modalregister from './Modalregister';
import Modalfinance from './Modalfinance';
import Commentbnlistforuser from './Commentbnlistforuser';
import Commentexlistforuser from './Commentexlistforuser';
import { URL,api } from '../api';
import Modaluserpay from './Modaluserpay';
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, PageHeader,Radio  } from 'antd';
import Modalregistersm from './Modalregistersm';
import Modaladdtex from './Modaladdtex';






export default class Homeuser extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: '',
            Psaaword:'',
            modal: false,
            iduser:'',
             nameuser:'',
            article:[],
            articlesm:[],
            articlepay:[],
            listen:[],
            articlepsf:[],
            url:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
            showbuttonpay:false,
            creck:'',
            price_typeregister:'',
            payinout:'',
            urlcer:'https://mua.kpru.ac.th/FrontEnd_Conferencekpru/',
            typeadd: '',
            opensystem : true, //ส่งบทความ
            opensystemprice : true, //ชำระเงิน
            opensystemsm : true, //ส่งบทความสัมมนา
            opensystemcer : true, //เกียรติบัตร

            status1:'',
            status23:'',
            status0:'',
            statusfull:'',
            name_rob:'',

        };
       
        this.submit = this.submit.bind(this);
        this.list = this.list.bind(this);
        this.list2 = this.list2.bind(this);
        this.handleChangetypeinout = this.handleChangetypeinout.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getatpsf = this.getatpsf.bind(this);
        this.getatpsfcheck = this.getatpsfcheck.bind(this);
        this.getrob = this.getrob.bind(this);

      }

      onChange = e => {
        console.log('radio checked', e.target.value);
        this.setState({
          typeadd: e.target.value,
        });
      };

      handleChangetypeinout(event) {   
        this.setState({payinout: event.target.value});
      }


    onTextChange = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

   getatpsf() {
        setTimeout(() => {
               
          api.get('registercon/SelectArticlespsf/'+localStorage.getItem('iduser'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ articlepsf: res.data})

             const status1 =  res.data.filter((word) => word.status	 === "1");
             const status23 =  res.data.filter((word) => word.status	 === "2" || word.status	 === "3");
             const status0 =  res.data.filter((word) => word.status	 === "0");

             this.setState({ status1: status1,
                             status23: status23,
                             status0: status0,

             })

           }) 
         }, 0);
     }

     getatpsfcheck() {
        setTimeout(() => {
               
          api.get('registercon/SelectArticlespsfforcheck/'+localStorage.getItem('iduser'))
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           if (res.data.length > 0) {
            this.setState({ statusfull: res.data[0].status})
           // const date = res.data[0].dateaddbn;
       
            



             }
           

           }) 
         }, 0);
     }


    getrob() {
        setTimeout(() => {
               
          api.get('registercon/Selectrobpsf')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           if (res.data.length > 0) {
            this.setState({ name_rob: res.data[0].name_rob})
           // const date = res.data[0].dateaddbn;
             }
           }) 
         }, 0);
     }

    submit = (event) => {
        event.preventDefault();

        var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
        datafrm.append("id", this.state.id);
        datafrm.append("name", this.state.name);
        datafrm.append("lname", this.state.lname);
        datafrm.append("age", this.state.age);
        datafrm.append("sex", this.state.sex);

        if (this.state.update === false) { //เช็คว่าเป็นหน้าสำหรับอัพเดตหรือไม่
            Axios.post('https://conference.kpru.ac.th/PHP/insert.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) })

        }
        else {
            Axios.post('https://conference.kpru.ac.th/PHP/update.php', datafrm)
                .then((res) => {
                    this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
                })
                .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
        }

    }

    componentDidMount() {

      // if (localStorage.getItem('name') == null) {
               
      //   window.location.href = 'https://e-student.kpru.ac.th/creditbank'
     
      //   } else {

      //   }
        
         this.setState({ iduser: localStorage.getItem('iduser')})
         this.setState({ nameuser: localStorage.getItem('prefix_name')+''+localStorage.getItem('nameuser')})

        setTimeout(() => {
            //ภายใน
            api.get('registercon/selectArticleconn/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

          setTimeout(() => {
            //ภายใน
            api.get('registercon/selectArticleconnpay/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlepay: res.data})
            }) 
      
          }, 0);


          // setTimeout(() => {
       
          //   api.get('registercon/selecttextforuserlist/'+localStorage.getItem('iduser'))
          //   .then(res => {
          //     console.log(res);
          
          //     this.setState({ listen: res.data})
          //     if (res.data[0].creck > 0) {
          //       this.setState({ showbuttonpay: true})
          //     }
          //      this.setState({ creck: res.data[0].creck})
          //       this.setState({ price_typeregister	: res.data[0].price_typeregister	})
          //   }) 
      
          // }, 0);


          setTimeout(() => {
            //ภายใน
            api.get('registercon/selectArticlesmconn/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlesm: res.data})
            }) 
      
          }, 0);



          setTimeout(() => {
               
            api.get('registercon/selectdateopen')
             .then(res => {
               console.log(res);
               //  this.setState({ bankname: res.data, loading: false })
               // this.setState({ dateopen: res.data})
               const result =  res.data.filter((word) => word.type_dateopen	 === "ส่งบทความ");
               //   console.log(result[0].start_dateopen);
               //   console.log(result[0].close_dateopen);
               const event = result[0].start_dateopen;
               const event2 = result[0].close_dateopen;

               const date = new Date();
               const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
               const dates = day+"-"+month+"-"+year ;
         
               const dateFrom = event;
               const dateTo = event2;
               // const dateTo = "10-11-2024";
               const dateCheck = dates;
              
               const d1 = dateFrom.split("-");
               const d2 = dateTo.split("-");
               const c = dateCheck.split("-");
         
               const from = new Date(d1[2], parseInt(d1[1])-1, d1[0]);  // -1 because months are from 0 to 11
               const to   = new Date(d2[2], parseInt(d2[1])-1, d2[0]);
               const check = new Date(c[2], parseInt(c[1])-1, c[0]);
               const checkshow = check >= from && check <= to;

              this.setState({ opensystem: checkshow})




              //เช็คชำระเงิน
              const resultpri =  res.data.filter((word) => word.type_dateopen	 === "ชำระเงิน");
              //   console.log(result[0].start_dateopen);
              //   console.log(result[0].close_dateopen);
              const eventpri = resultpri[0].start_dateopen;
              const event2pri = resultpri[0].close_dateopen;

              const datepri = new Date();
              const [monthpri, daypri, yearpri]  = [String(datepri.getMonth() + 1).padStart(2, '0'), String(datepri.getDate()).padStart(2, '0'), datepri.getFullYear()];
              const datespri = daypri+"-"+monthpri+"-"+yearpri ;
        
              const dateFrompri = eventpri;
              const dateTopri = event2pri;
              // const dateTo = "10-11-2024";
              const dateCheckpri = datespri;
             
              const d1pri = dateFrompri.split("-");
              const d2pri = dateTopri.split("-");
              const cpri = dateCheckpri.split("-");
        
              const frompri = new Date(d1pri[2], parseInt(d1pri[1])-1, d1pri[0]);  // -1 because months are from 0 to 11
              const topri   = new Date(d2pri[2], parseInt(d2pri[1])-1, d2pri[0]);
              const checkpri = new Date(cpri[2], parseInt(cpri[1])-1, cpri[0]);
              const checkshowpri = checkpri >= frompri && checkpri <= topri;

             this.setState({ opensystemprice: checkshowpri})


            //บทความสัมมนา
             const resultsm =  res.data.filter((word) => word.type_dateopen	 === "ส่งบทความสัมนา");
             //   console.log(result[0].start_dateopen);
             //   console.log(result[0].close_dateopen);
             const eventsm = resultsm[0].start_dateopen;
             const event2sm = resultsm[0].close_dateopen;

             const datesm = new Date();
             const [monthsm, daysm, yearsm]  = [String(datesm.getMonth() + 1).padStart(2, '0'), String(datesm.getDate()).padStart(2, '0'), datesm.getFullYear()];
             const datessm = daysm+"-"+monthsm+"-"+yearsm ;
       
             const dateFromsm = eventsm;
             const dateTosm = event2sm;
             // const dateTo = "10-11-2024";
             const dateChecksm = datessm;
            
             const d1sm = dateFromsm.split("-");
             const d2sm = dateTosm.split("-");
             const csm = dateChecksm.split("-");
       
             const fromsm = new Date(d1sm[2], parseInt(d1sm[1])-1, d1sm[0]);  // -1 because months are from 0 to 11
             const tosm   = new Date(d2sm[2], parseInt(d2sm[1])-1, d2sm[0]);
             const checksm = new Date(csm[2], parseInt(csm[1])-1, csm[0]);
             const checkshowsm = check >= fromsm && checksm <= tosm;

            this.setState({ opensystemsm: checkshowsm})


              //เกียรติบัตร
              const resultcer =  res.data.filter((word) => word.type_dateopen	 === "เกียรติบัตร");
              //   console.log(result[0].start_dateopen);
              //   console.log(result[0].close_dateopen);
              const eventcer = resultcer[0].start_dateopen;
              const event2cer = resultcer[0].close_dateopen;
 
              const datecer = new Date();
              const [monthcer, daycer, yearcer]  = [String(datecer.getMonth() + 1).padStart(2, '0'), String(datecer.getDate()).padStart(2, '0'), datecer.getFullYear()];
              const datescer = daycer+"-"+monthcer+"-"+yearcer ;
        
              const dateFromcer = eventcer;
              const dateTocer = event2cer;
              // const dateTo = "10-11-2024";
              const dateCheckcer = datecer;
             
              const d1cer = dateFromcer.split("-");
              const d2cer = dateTocer.split("-");
              const ccer = dateChecksm.split("-");
        
              const fromcer = new Date(d1cer[2], parseInt(d1cer[1])-1, d1cer[0]);  // -1 because months are from 0 to 11
              const tocer   = new Date(d2cer[2], parseInt(d2cer[1])-1, d2cer[0]);
              const checkcer = new Date(ccer[2], parseInt(ccer[1])-1, ccer[0]);
              const checkshowcer = checkcer >= fromcer && checkcer <= tocer;
 
             this.setState({ opensystemcer: checkshowcer})






             }) 
           }, 0);

       this.getatpsf()
       this.getatpsfcheck()
       //this.getrob()
    }


    list() {
        this.setState({ iduser: localStorage.getItem('iduser')})
        setTimeout(() => {
            //ภายใน
            api.get('registercon/selectArticleconn/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ article: res.data})
            }) 
      
          }, 0);

          setTimeout(() => {
            //ภายใน
            api.get('registercon/selectArticleconnpay/'+localStorage.getItem('iduser'))
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
              this.setState({ articlepay: res.data})
            }) 
      
          }, 0);
    }


    list2() {
     // this.setState({ iduser: localStorage.getItem('iduser')})
      setTimeout(() => {
          //ภายใน
          api.get('registercon/selectArticlesmconn/'+localStorage.getItem('iduser'))
          .then(res => {
            console.log(res);
          //  this.setState({ bankname: res.data, loading: false })
            this.setState({ articlesm: res.data})
          }) 
    
        }, 0);
  }


    render() {

        // const date = new Date();
        // const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
        // const dates = day+"-"+month+"-"+year ;

         //  console.log(this.state.nameuser)
        //   console.log(this.state.price_typeregister)
          
            console.log(this.state.opensystem)
             console.log(this.state.statusfull)
        //    console.log(this.state.opensystemprice)

        return (
            <MDBContainer className="mt-1 " fluid >
                <MDBCard >
                    
                    <MDBCardBody>
                        {/* <h1>{this.state.update === true ? <>อัพเดตข้อมูลสมาชิก</> : <>เพิ่มสมาชิก</>}</h1> */}
                      <div className='text-right font-weight-bold' ><p>สวัสดีคุณ {localStorage.getItem('nameuser')}</p></div>  
                        
  {/* <div className='mb-2 mt-2'> <Modalregister iduser={this.state.iduser} list={this.list} /></div>   */}
                      {/* <MDBAlert color="success" >
                      <MDBBox tag="p"><h4><strong>รายการลงทะเบียนนำเสนอ</strong></h4></MDBBox>
                     </MDBAlert> */}

                            {/* <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                               
                                    title="รายการลงทะเบียน"
                                    subTitle=""
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                            </MDBAlert>     */}



                        {/* <MDBTable bordered responsive small>
                                    <MDBTableHead color="grey darken-1" textWhite>
                                        <tr>
                                      
                                        <th>ชื่อ-นามสกุล</th>
                                        <th>หน่วยงาน</th>
                                        <th>เบอร์โทร</th>
                                        <th>เลขที่ผู้เสียภาษีของหน่วยงาน</th>
                                        <th>ที่อยู่แสดงในใบเสร็จ</th>
                                        <th>วันที่ทำรายการ</th>
                                        <th>ชำระเงิน</th>
                                        <th>เกียรติบัตร</th>
                                      
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                    {this.state.listen.map((article,index )  => 
                                    <tr>
                                    
                                      <td>{article.pnamelisten}{article.namelisten} {article.lnamelisten}</td>
                                      <td>{article.agencylisten}</td>
                                      <td>{article.tellisten}</td>
                                      <td>
                                        {article.registerlisten_taxnumber === '' || article.registerlisten_taxnumber === null ?<>
                                          <Modaladdtex agencylisten={article.agencylisten	}	send_id={article.send_id}	 />
                                        </>:<>
                                          {article.registerlisten_taxnumber}
                                        </>}
                                        </td>
                                      <td>{article.registerlisten_taxadress} {article.registerlisten_taxDISTRICT} {article.registerlisten_taxAMPHUR} {article.registerlisten_taxPROVINCE	}  {article.registerlisten_taxCODE		}  </td>
                                      <td>{article.sendlisten_date}</td>
                                      <td>

                                        {this.state.opensystemprice === true ?<>
                                        
                                      
                                  {article.registerlisten_taxnumber === '' || article.registerlisten_taxnumber === null ?<>
                                  กรุณาเพิ่มข้อมูลผู้เสียภาษีของมหาวิทยาลัย ก่อนชำระเงิน
                                  </>:<>

                                      {Number(article.price_typeregister)	> 0 ? <>
                                                {article.creck	=== '0'?<>
                                                  <div className="mb-2">
                                                  <label rules={[{ required: true }]} className="font-weight-bold">  เลือกรูปแบบใบเสร็จที่ต้องการ</label> <label className="red-text">(ใบเสร็จรูปแบบเซ็นสดจะได้รับในวันงาน)</label><br/>
                                                  
                                                      <Radio.Group onChange={this.handleChangetypeinout} required={true}  >
                                                        <Radio value="1">ใบเสร็จลายเซ็นสด(รับในวันงาน) </Radio>
                                                        <Radio value="2">ใบเสร็จลายเซ็นอิเล็กทรอนิกส์ (พิมพ์ในระบบ) </Radio>
                                                      </Radio.Group>
                                                  </div> 
                                                      {this.state.payinout === '1'?<>
                                                              <Modaluserpay id_send={article.id_listen} send_id={article.send_id} typeac_id={3} price_typeregister={article.price_typeregister} list={this.list} payinout={'1'}/>
                                                      </>:<>
                                                          {this.state.payinout === '2'?<>
                                                              <Modaluserpay id_send={article.id_listen} send_id={article.send_id} typeac_id={3} price_typeregister={article.price_typeregister} list={this.list} payinout={'2'}/>
                                                          </>:<>
                                                          </>}
                                                      </>}
                                                 
                                                </>:<>
                                                {article.sign === '1'?<>
                                                  <MDBBadge pill color="default">ชำระเงินสำเร็จ</MDBBadge><br/>
                                                  <MDBBadge pill color="primary">ติดต่อรับใบเสร็จชำรับเงินในวันนำเสนอ</MDBBadge>
                                                </>:<>
                                                <MDBContainer className='text-left'><a href={`https://e-finance.kpru.ac.th/receipt_research?customer_id=${article.ref1}&receipt_book=${article.BOOK}&receipt_no=${article.NO}&sign=true`}><MDBBtn color="unique" size='sm'>พิมพ์ใบเสร็จ</MDBBtn></a></MDBContainer> 
                                                </>}
                                                <br/>
                                                {dates === '02-10-2024' ?<>
                                                  <MDBBtn color="secondary" size="sm" href={'https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/certificase1.php?id_listen='+article.id_listen } target="_blank"> ดาวน์โหลดเกียรติบัตรเข้าร่วม</MDBBtn>
                                                
                                                </>:<></>}
                                               
                                                  
                                                </>} 
                                          </>:<>
                                                <p className="teal-text"> ฟรี</p>
                                          </>}
                                             

                                              </>}

                                              </>:<>
                                             <p className="font-weight-bold"> ระบบปิดชำระเงินแล้ว</p>
                                              </>}
                                      </td>
                                      <td> 
                                      {this.state.opensystemcer === true?<>
                                      <MDBBtn color="unique" size="sm" href={`https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/certificaseregister.php?id_listen=${article.send_id}`}  target="_blank">download <br/>เกียรติบัตร</MDBBtn>
                                      </>:<>
                                      <p className="font-weight-bold"> -</p>
                                      </>}
                                        </td>
                                    </tr>
                                )}
                           
                                    </MDBTableBody>
                            </MDBTable> */}


{this.state.statusfull === '1' ?<>
    <div className='text-center'><MDBBtn color="deep-purple" disabled><MDBIcon icon="plus-square" />  เพิ่มผลงาน</MDBBtn></div> 
</>:<>
        {this.state.statusfull === '2' || this.state.statusfull === '3' ?<>
            <Modalregister iduser={this.state.iduser} nameuser={this.state.nameuser}  getatpsf={this.getatpsf} />   
        </>:<>
                    {this.state.statusfull === '0' ?<>
                        <Modalregister iduser={this.state.iduser} nameuser={this.state.nameuser}  getatpsf={this.getatpsf} />   
                    </>:<>
                          <Modalregister iduser={this.state.iduser} nameuser={this.state.nameuser}  getatpsf={this.getatpsf} />   
                    </>}
        </>}
</>}

                         
                     


                                          {/* เพิ่มบทความ */}
                                          {/* {this.state.price_typeregister === "0" ?<>
                                          <div className='mb-2 mt-2 text-left'> 
                                          <div className='text-center mt-3'>
                                            <h4>เพิ่มบทความ</h4>
                                                  <Radio.Group onChange={this.onChange} value={this.state.typeadd}>
                                                    <Radio value={1}>เพิ่มบทความวิจัย/โครงงาน</Radio>
                                                    <Radio value={2}>เพิ่มบทความสัมมนา</Radio>
                                                   
                                                  </Radio.Group>
                                                  </div> 
                                          
                                            
                                              {this.state.typeadd === 1 ?<>
                                              {this.state.opensystem === true?<>
                                              <Modalregister iduser={this.state.iduser} list={this.list} />
                                              </>:<>
                                              <p className="text-center font-weight-bold mt-2">ระบบปิดส่งบทความแล้ว</p>
                                              </>}
                                              
                                              </>:<>
                                              {this.state.typeadd === 2 ?<>
                                                {this.state.opensystemsm === true?<>
                                                <Modalregistersm iduser={this.state.iduser} list={this.list2} />
                                                </>:<>
                                                <p className="text-center font-weight-bold mt-2">ระบบปิดส่งบทความแล้ว</p>
                                                </>}
                                                
                                              </>:<></>}
                                              
                                              </>}

                                            </div>  
                                          </>:<>
                                                {this.state.showbuttonpay === true && this.state.price_typeregister	> 0 ?<>
                                                  <div className='mb-2 mt-2 text-left'> 
                                                    
                                                  <div className='text-center mt-3'>
                        
                                                  <h4>เพิ่มบทความ</h4>
                                                  <Radio.Group onChange={this.onChange} value={this.state.typeadd}>
                                                    <Radio value={1}>เพิ่มบทความวิจัย/โครงงาน</Radio>
                                                    <Radio value={2}>เพิ่มบทความสัมมนา</Radio>
                                                   
                                                  </Radio.Group>
                                                  </div> 
                      

                                              {this.state.typeadd === 1 ?<>
                                                {this.state.opensystem === true?<>
                                                 <Modalregister iduser={this.state.iduser} list={this.list} />
                                                </>:<>
                                                 <p className="text-center font-weight-bold mt-2">ระบบปิดส่งบทความแล้ว</p>
                                                </>}
                                             
                                              </>:<>
                                              {this.state.typeadd === 2 ?<>
                                             
                                                {this.state.opensystemsm === true?<>
                                                <Modalregistersm iduser={this.state.iduser} list={this.list2} />
                                                </>:<>
                                                <p className="text-center font-weight-bold mt-2">ระบบปิดส่งบทความแล้ว</p>
                                                </>}
                                              </>:<></>}
                                              
                                              </>}
                                                    
                                                    
                                                </div>  
                                                </>:<>
                                                <div className='text-center'><h4>เพิ่มบทความ</h4> <br/>กรุณาชำระเงินก่อนเพิ่มบทความ</div> 
                                                </>  }
                                              </>} */}

                              
                            
                           

                           {/* <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                    title="รายการลงทะเบียนนำเสนอ"
                                    subTitle=""
                                    avatar={{ src: 'https://e7.pngegg.com/pngimages/993/338/png-clipart-newspaper-computer-icons-news-media-others-text-logo.png' }}
                                />
                            </MDBAlert>    
                           */}
                           

                             {/* <MDBTable bordered responsive small>
                                    <MDBTableHead color="grey darken-1" textWhite>
                                        <tr>
                                        <th>ลำดับ</th>
                                        <th>ชื่อบทความ</th>
                                        <th>ผู้นำเสนอ</th>
                                        <th>ประเภท</th>
                                        <th>ไฟล์บทความ</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                    {this.state.article.map((article,index )  => 
                                    <tr>
                                    <td>{index+1}</td>
                                    <td>{article.name_article}</td>
                                    <td>{article.name_present}</td>
                                    <td>{article.presentype_name}</td>
                                    <td>
                                                        <MDBBtn color="indigo" size="sm" href={`${this.state.url+article.send_uploadeword1}`}  target="_blank">WORD</MDBBtn>
                                                        <MDBBtn color="pink" size="sm" href={`${this.state.url+article.send_uploadepdf1}`}  target="_blank">PDF</MDBBtn>
                                                        </td>
                                    </tr>
                                )}
                           
                                    </MDBTableBody>
                            </MDBTable> */}


                            {/* <MDBAlert color="success" >
                            <MDBBox tag="p"><h4><strong>ตรวจสอบสถานะบทความ</strong></h4></MDBBox>
                             </MDBAlert> */}
                           
                           <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="ตรวจสอบสถานะผลงาน"
                                    subTitle=""
                                    avatar={{ src: 'https://cdn.icon-icons.com/icons2/560/PNG/512/Blog_icon-icons.com_53707.png' }}
                                />
                            </MDBAlert>   
   

                    <MDBTable bordered responsive small>
                        <MDBTableHead color="grey darken-1" textWhite>
                            <tr>
                            <th>ลำดับ</th>
                            <th>ผลงาน</th>
                            <th>ผู้ส่งผลงาน</th>
                             <th>วันที่ส่งผลงาน</th>
                            <th>ข้อเสนอแนะคณะกรรมการกลั่นกรอง</th>
                            <th>ข้อเสนอแนะคณะกรรมการ</th>
                            <th>สถานะ</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                        {this.state.articlepsf.map((articlepay,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>ผลงาน KPRU PSF ระดับที่ {articlepay.typelevel}</td>
                         <td>{articlepay.nameuser }</td>
                         <td>{articlepay.dateadd }</td>
                        <td><Commentbnlistforuser  id_emp={articlepay.id_emp} id_articlepsf={articlepay.id_articlepsf}/></td>
                        <td>
                          <Commentexlistforuser  id_emp={articlepay.id_emp} id_articlepsf={articlepay.id_articlepsf}/>
                        </td>
                        <td>{articlepay.status === '2' ?<>    <MDBAlert color="success">
                              <a href="#!" className="alert-link">ผ่านการพิจารณา</a>
                            </MDBAlert></>:<><MDBAlert color="warning">
                              <a href="#!" className="alert-link">อยู่ระหว่างการพิจารณา</a>
                            </MDBAlert></>}

                            {articlepay.stapat === '3'?<>   
                            {/* <MDBBtn color="secondary" size="sm" href={'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/certificate.php?id_sendcf='+articlepay.id_send } target="_blank"> ดาวน์โหลดเกียรติบัตร</MDBBtn> */}
                            </>:<></>}
                        </td>
                        
                        </tr>
                      )}
                           
                        </MDBTableBody>
                    </MDBTable>




{/* สัมมนา */}

                            {/* <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                    title="รายการลงทะเบียนบทความสัมมนา"
                                    subTitle=""
                                    avatar={{ src: 'https://cdn.icon-icons.com/icons2/560/PNG/512/Heading-Tag_icon-icons.com_53735.png' }}
                                />
                            </MDBAlert>    
                        
                           

                             <MDBTable bordered responsive small> 
                                    <MDBTableHead color="grey darken-1" textWhite >
                                        <tr>
                                        <th>ลำดับ</th>
                                        <th>ชื่อบทความ</th>
                                        <th>ผู้นำเสนอ</th>
                                        <th>ประเภท</th>
                                        <th>ไฟล์บทความ</th>
                                        <th>เกียรติบัตร</th>
                                       
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                    {this.state.articlesm.map((articlesm,index )  => 
                                    <tr>
                                    <td>{index+1}</td>
                                    <td>{articlesm.name_articlesm}</td>
                                    <td>{articlesm.name_presentsm}</td>
                                    <td>{articlesm.presentype_name}</td>
                                    <td>
                                                        <MDBBtn color="indigo" size="sm" href={`${this.state.url+articlesm.send_uploadeword1sm}`}  target="_blank">WORD</MDBBtn>
                                                        <MDBBtn color="pink" size="sm" href={`${this.state.url+articlesm.send_uploadepdf1sm}`}  target="_blank">PDF</MDBBtn>
                                                        </td>
                                     <td>
                                     {this.state.opensystemcer === true?<>
                                      {articlesm.name_reward	== null ?<>
                                        <MDBBtn color="unique" size="sm" href={`https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/certificasepresentsm.php?id_sent=${articlesm.id_sendsm}`}  target="_blank">download <br/>เกียรติบัตร</MDBBtn>
                                     </>:<>
                                     <MDBBtn color="unique" size="sm" href={`https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/certificasepresentrewardsm.php?id_sent=${articlesm.id_sendsm}`}  target="_blank">download <br/>เกียรติบัตร</MDBBtn>
                                     
                                     </>}
                                     </>:<>
                                     -
                                     </>}
                                     </td>
                                  
                                    </tr>
                                )}
                           
                                    </MDBTableBody>
                            </MDBTable> */}

  <div><p>ติดต่อสอบถามเพิ่มเติม คุณพิกุล อินไผ่ เบอร์ภายใน 1479</p></div> 
                       
                    </MDBCardBody>
                   <hr/>
                    
                </MDBCard>
                </MDBContainer>
        )
    }
}

